import { useState, useCallback, useEffect } from 'react';
import { zodErrorResolver } from '../Utilities/Utilities';

function useFormValidation({ schema, formData, isSubmit }) {
  const [errors, setErrors] = useState({});

  // Validation Logic
  const validateForm = useCallback(() => {
    const validation = schema.safeParse(formData);

    if (!validation.success) {
      return validation.error.issues;
    }
    return '';
  }, [schema, formData]);

  // Trigger Validation on Submit
  useEffect(() => {
    if (isSubmit) {
      const validationError = validateForm();
      if (validationError) {
        const newErrors = zodErrorResolver(validationError);
        // Only update state if errors have changed
        if (JSON.stringify(newErrors) !== JSON.stringify(errors)) {
          setErrors(newErrors);
        }
      } else {
        if (Object.keys(errors).length > 0) {
          setErrors({});
        }
      }
    }
  }, [isSubmit, validateForm, errors]);

  return {
    errors,
    validateForm,
  };
}

export default useFormValidation;
